module.exports = __webpack_public_path__ + "assets/img/confirm_error_img.1bc23d1c.png";